// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminLogin_wrapper__x73UM"};